import { useMemo } from 'react'

import { structureIdTypes } from '@/constants/dmp-connect'

import { useGetInteropCodesQuery } from '@/core/services/dmp-connect-js2'
import { PracticeLocation } from '@/core/types/dmp-connect'

export function usePracticeLocationDetails(selectedPracticeLocation: PracticeLocation | undefined) {
  const { activitySectors } = useGetInteropCodesQuery(
    { s_codeIds: ['activitySectors'] },
    {
      selectFromResult: ({ data }) => ({
        activitySectors: data?.activitySectors ?? [],
      }),
    }
  )

  const structureName = selectedPracticeLocation?.s_practiceLocationName ?? ''

  const structureIdType = useMemo(
    () =>
      Object.values(structureIdTypes).find(
        (type) => type.firstDigit === Number(selectedPracticeLocation?.s_practiceLocationStructureId.charAt(0))
      )?.label ?? '',
    [selectedPracticeLocation]
  )

  const structureId = selectedPracticeLocation?.s_practiceLocationStructureId ?? ''

  const activitySector = useMemo(
    () => activitySectors.find(({ s_code }) => s_code === selectedPracticeLocation?.s_practiceLocationActivity)?.s_displayName ?? '',
    [activitySectors, selectedPracticeLocation]
  )

  return {
    structureName,
    structureIdType,
    structureId,
    activitySector,
  }
}
